exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".angucomplete-dropdown{border:1px solid #ccc;border-radius:2px;width:250px;padding-top:20px;padding:6px;cursor:pointer;z-index:9999;position:absolute;margin-top:32px;background-color:#fff;overflow-y:auto;max-height:200px}.autocomplete-highlight{color:red}.user-image{height:128px!important;width:128px!important;cursor:pointer}.user-image-container .selected,.user-image-container img:hover{border:2px solid red}.iconBtn{font-size:14px!important}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./client/site.css
// module id = 346
// module chunks = 0